import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { merge, mapValues, forEach } from "../utils/lodash";
import { initial, format, setLocaleToInstance } from "../utils/StringFomat";
import { getLang, getRandomKey, convertPandaI18nFormatToLocalResource, warn, formatLang, error, getOSLang, setCookieLang, isRTL, debugInfo } from "../utils";
import { pandaEvent, setConfig } from "../services";
import { g } from "../const/globalThis";
/**
 * 设置语种
 * @param langTag 语种
 * @param isGlobalNotify 是否全局通知
 */ export function setLang(langTag) {
    var isGlobalNotify = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!langTag) return;
    // 由于后续的文案消费依赖标准的format，故设置需要做处理
    var standardLang = formatLang(langTag);
    // set cookie, 由于使用中依然 后端可能存在依然使用老的规范，故设置cookie依然使用用户设置的值
    setCookieLang(standardLang);
    debugInfo("Set lang to ".concat(standardLang));
    if (isGlobalNotify) {
        pandaEvent.emit("CHANGE_LANG", standardLang);
    }
}
var I18n = /*#__PURE__*/ function() {
    "use strict";
    function I18n(params) {
        var _this = this;
        _class_call_check(this, I18n);
        var _params, _params1, _params2, _params3, _params4, _params5, _params6;
        /**
   * 用组件自持有翻译初始化stringformat实例
   * @param {object} locale 组件自持有翻译
   * @param {string} defaultLang 自定义语种
   */ _define_property(this, "locale", {});
        /** 当前实例的实际语种 */ _define_property(this, "currentLang", "");
        /** $i18n组件名（组件独有） */ _define_property(this, "componentName", "");
        /** $i18n组件包名 (组件独有) */ _define_property(this, "packageName", "");
        /** 标识 */ _define_property(this, "type", void 0);
        /** $i18n实例名 */ _define_property(this, "name", void 0);
        /** 自定义的语种，设置后该实例语种不再受环境语种影响 */ _define_property(this, "customLang", void 0);
        /** 设置Panda全局配置 */ _define_property(this, "setConfig", setConfig);
        _define_property(this, "isRTL", function() {
            return isRTL(_this.currentLang);
        });
        this.componentName = ((_params = params) === null || _params === void 0 ? void 0 : _params.componentName) || "";
        this.type = (_params1 = params) === null || _params1 === void 0 ? void 0 : _params1.type;
        this.packageName = ((_params2 = params) === null || _params2 === void 0 ? void 0 : _params2.packageName) || "";
        // 当前如果用了packageName方案则使用默认实例的name做后缀，后续多packageName的实例将覆盖
        this.name = this.componentName ? "".concat(this.componentName, ".").concat(this.packageName && ((_params3 = params) === null || _params3 === void 0 ? void 0 : _params3.name) ? params.name : getRandomKey()) : getRandomKey();
        // 当指定了lang之后该实例将锁定lang，不再受环境和事件影响
        if ((_params4 = params) === null || _params4 === void 0 ? void 0 : _params4.lang) {
            this.customLang = params.lang;
        }
        /**
     * 传入locale不合并全局!
     * 传入componentName和locale自动处理locale二层结构
     * 传入componentName合并扩展语种
     */ if ((_params5 = params) === null || _params5 === void 0 ? void 0 : _params5.locale) {
            // 组件可能传递是会多一层nameSpace，需要脱离，如果是组件不需要合并cdn的文案
            // TLocalResource | TLocalResourceWithNs => TLocalResource
            this.locale = this.componentName ? mapValues(params.locale, function(_langLocale) {
                var _$_langLocale;
                return ((_$_langLocale = _langLocale) === null || _$_langLocale === void 0 ? void 0 : _$_langLocale[_this.componentName]) || _langLocale || {};
            }) : params.locale;
            // 合并扩展语种， 支持以组件名同时也支持用包名
            var ns = this.componentName || this.packageName;
            if (g._PANDA_EXUI) {
                Object.keys(g._PANDA_EXUI).forEach(function(lang) {
                    if (g._PANDA_EXUI && g._PANDA_EXUI[lang][ns]) {
                        _this.locale[lang] = _this.locale[lang] ? merge(_this.locale[lang], g._PANDA_EXUI[lang][ns]) : g._PANDA_EXUI[lang][ns];
                    }
                });
            }
        } else {
            this.locale = convertPandaI18nFormatToLocalResource(g._PANDA_I18N);
        }
        this.currentLang = ((_params6 = params) === null || _params6 === void 0 ? void 0 : _params6.lang) || getLang();
        pandaEvent.on("CHANGE_LANG", function(lang) {
            if (!_this.customLang) {
                _this.currentLang = lang;
            }
        });
        // lang只记录强制lang，环境lang跟随环境走
        initial(this.locale, {
            name: this.name,
            lang: this.customLang,
            packageName: this.packageName,
            $i18n: this
        });
    }
    _create_class(I18n, [
        {
            key: "init",
            value: function init(params) {
                var _params, _params1;
                // 如果原实例被记入一个type/packageName，由此新生成的实例也将被打入同一个type/packageName
                return new I18n(Object.assign(_object_spread({}, params), {
                    packageName: ((_params = params) === null || _params === void 0 ? void 0 : _params.packageName) || this.packageName,
                    type: ((_params1 = params) === null || _params1 === void 0 ? void 0 : _params1.type) || this.type,
                    name: this.name
                }));
            }
        },
        {
            /**
   * change current language
   * @deprecated 之后将逐步废弃此方法
   */ key: "change",
            value: function change(langTag) {
                warn("Pls use $i18n.setLang instead!");
                this.setLang(langTag);
            }
        },
        {
            /**
   * change current language
   * @param {string} langTag language tag
   */ key: "setLang",
            value: function setLang1(langTag) {
                var isGlobalNotify = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                setLang(langTag, isGlobalNotify);
                this.currentLang = formatLang(langTag);
            }
        },
        {
            /** get current language */ key: "getLang",
            value: function getLang() {
                return this.currentLang;
            }
        },
        {
            /** Format string by key */ key: "get",
            value: function get(keyValue, variable) {
                var _keyValue, _keyValue_id, _keyValue1;
                var isKeyValueString = typeof keyValue === "string";
                var id = isKeyValueString ? (_keyValue = keyValue) === null || _keyValue === void 0 ? void 0 : _keyValue.trim() : (_keyValue_id = keyValue.id) === null || _keyValue_id === void 0 ? void 0 : _keyValue_id.trim();
                var defaultMessage = isKeyValueString ? keyValue : keyValue.dm;
                // namespace 当前只针对组件名
                var nameSpace = isKeyValueString ? this.componentName : keyValue.ns || this.componentName;
                // 指定语种
                var lang = !isKeyValueString && keyValue.lang ? keyValue.lang : this.currentLang;
                var pure = isKeyValueString ? false : !!((_keyValue1 = keyValue) === null || _keyValue1 === void 0 ? void 0 : _keyValue1.pure);
                return format({
                    id: id,
                    defaultMessage: defaultMessage
                }, variable || null, {
                    name: this.name,
                    type: this.type,
                    nameSpace: nameSpace,
                    lang: lang,
                    pure: pure
                });
            }
        },
        {
            /** 在当前$i18n实例中添加翻译文案 */ key: "addLocale",
            value: function addLocale(locale) {
                this.locale = merge(this.locale, locale);
                setLocaleToInstance(this.locale, this.name);
            }
        },
        {
            /**
   * 在当前$i18n实例中替换locale文案, 可指定自定义组件名来标识实例来源
   * !!!请确保该使用的组件不会以npm的包的形式提供给其他项目使用，否则会造成实例冲突
   * @param locale
   * @param packageName 包名（插件工程建议projectName）
   */ key: "setLocale",
            value: function setLocale(locale, packageName) {
                this.locale = locale;
                this.packageName = packageName || getRandomKey();
                setLocaleToInstance(this.locale, this.name);
            }
        },
        {
            /** 在当前$i18n实例增量添加翻译文案 */ key: "addLocaleByKey",
            value: function addLocaleByKey(locale) {
                var _this = this;
                forEach(locale, function(langLocale, key) {
                    forEach(langLocale, function(value, lang) {
                        _this.locale[lang] = _this.locale[lang] || {};
                        _this.locale[lang][key] = value;
                    });
                });
                setLocaleToInstance(this.locale, this.name);
            }
        },
        {
            /** 重新加载语言包资源到当前$i18n实例 */ key: "reloadPackLocale",
            value: function reloadPackLocale() {
                this.addLocale(convertPandaI18nFormatToLocalResource(g._PANDA_I18N));
            }
        },
        {
            /** 设置该实例的自定义的lang (Pay attention to usage) */ key: "setCustomLang",
            value: function setCustomLang(lang) {
                this.currentLang = lang;
                this.customLang = lang;
            }
        },
        {
            /** 根据key返回翻译列表 */ key: "getLocaleByKey",
            value: function getLocaleByKey(key) {
                var myLocale = {};
                forEach(this.locale, function(locale, lang) {
                    myLocale[lang] = locale[key] || "";
                });
                return myLocale;
            }
        },
        {
            /** 将当前实例置入到全局的低码环境中 */ key: "initLowcode",
            value: function initLowcode() {
                g.$i18n_lowcode = this;
            }
        },
        {
            /** 将该实例锁定为OS环境的语种，如不在os环境中则不会生效 */ key: "lockOSLang",
            value: function lockOSLang() {
                var osLang = getOSLang();
                if (osLang) {
                    this.setCustomLang(osLang);
                }
            }
        },
        {
            /** 设置一个标记位，标识该实例，开发专用!!! */ key: "__setType",
            value: function __setType(type) {
                this.type = type;
            }
        },
        {
            /** 初始化组件包实例（将初始化多个实例） */ key: "initPackage",
            value: function initPackage(param) {
                var name = param.name, locales = param.locales;
                var _this = this;
                // this.packageName = name;
                if (locales) {
                    var componentMap = {};
                    Object.values(locales).forEach(function(locale) {
                        Object.keys(locale).forEach(function(ns) {
                            if (typeof locale[ns] === "string") {
                                error("no support locales type");
                            } else if (!componentMap[ns]) {
                                componentMap[ns] = _this.init({
                                    componentName: ns,
                                    locale: locales,
                                    packageName: name
                                });
                            }
                        });
                    });
                }
            }
        }
    ]);
    return I18n;
}();
export var init = function(params) {
    return new I18n(params);
};
export { I18n };
